import DocumentToolNav from '@/components/DocumentToolNav';
import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';
import { isDesktop } from '@/lib/platform';
import AppHeader from './desktop/AppHeader';
import ContactSlideOver from './desktop/ContactSlideOver';

export default function ViewerLayout() {
  if (isDesktop()) {
    return (
      <div className="scrivar-desktop h-screen flex flex-col">
        <AppHeader variant="editor" />
        <main className="flex-1 min-w-0 min-h-0 flex flex-col">
          <DocumentToolNav />
          <Outlet />
        </main>
        <ContactSlideOver />
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <TopNav />
      <main className="flex-1 min-w-0 min-h-0 flex flex-col">
        <DocumentToolNav />
          <Outlet />
      </main>
    </div>
  );
}
